export const insuranceAffiliation = [
  {
    id: 1,
    name: 'Molina',
    description: null,
    createdAt: '2019-09-09T20:47:40.453Z',
    updatedAt: '2019-09-09T20:47:40.453Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Cigna',
    description: null,
    createdAt: '2019-09-09T20:47:40.452Z',
    updatedAt: '2019-09-09T20:47:40.452Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Humana',
    description: null,
    createdAt: '2019-09-09T20:47:40.452Z',
    updatedAt: '2019-09-09T20:47:40.452Z',
    createdBy: null,
    updatedBy: null,
  },
];
